import { useMutation } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCall";

export const useSendEmail = () => {
  return useMutation({
    mutationFn: (data) => {
      const request = {
        method: "post",
        url: "send-email",
        params: "",
        data: data,
      };
      return callApi(request);
    },
  });
};
